import BookingLoader from '../../assets/images/bookingLoader.gif';
import style from '../../Style.module.css';
import React from 'react';

const AbsoluteLoader = (props) => {
    return(
        <img src={BookingLoader} className={style.loader} />
    )
}

export default AbsoluteLoader;